'use strict';

const materialIcon = require('../materialIcon');

/**
 * Displays a feedback message within a specified container.
 * The message is automatically removed after a specified duration.
 * @param {Object} options - Configuration options for the feedback message.
 * @param {string} options.containerSelector - The selector for the container where the message will be appended.
 * @param {string} options.message - The text content of the feedback message.
 * @param {string} options.iconHTML - HTML string for the icon to be displayed in the message.
 * @param {string} options.alertType - Class to define the type of alert (e.g., 'alert-success', 'alert-danger').
 * @param {number} [options.timeout=3000] - Duration in milliseconds before the message is automatically removed.
 * @param {boolean} options.disableAutoClosing - To avoid automatically removal of message
 * @param {boolean} options.disableCloseButton - To show/hide the close button
 */
function showToastMessage(options) {
    // Default options with customization possibilities
    const defaults = {
        containerSelector: '.feedback-element',
        alertType: 'alert-danger',
        alertId: '',
        alertClass: '',
        alertQa: '',
        message: 'error',
        iconHTML: '',
        timeout: 5000,
        disableAutoClosing: false,
        disableCloseButton: false
    };

    // Merge defaults with user-provided options
    const settings = { ...defaults, ...options };

    // Select the container where the message will be appended
    const feedbackElement = $(settings.containerSelector);

    if (feedbackElement.length) {
        let icon = '';
        if (settings.iconHTML?.length) {
            icon = settings.iconHTML;
        } else if (settings.alertType === 'alert-danger') {
            icon = materialIcon.error;
        } else if (settings.alertType === 'alert-warning') {
            icon = materialIcon.warning;
        } else if (settings.alertType === 'alert-success') {
            icon = materialIcon.check_circle_outline;
        } else if (settings.alertType === 'alert-info') {
            icon = materialIcon.info;
        }

        const alert = document.createElement('div');

        alert.role = 'alert';
        alert.id = settings.alertId;
        alert.dataset.qa = settings.alertQa;
        alert.className = `
            alert ${settings.alertType}
            ${!settings.disableCloseButton ? 'alert-dismissible fade show' : ''}
            ${!settings.disableAutoClosing ? 'toast-alert' : ''}
            ${settings.alertClass} px-0
        `.trim();

        alert.innerHTML = `
            <div class="container d-flex align-items-center position-relative ${!settings.disableCloseButton ? 'pe-9' : ''}">
                ${icon.length > 0 ? `
                    <span class="svg-wrapper-inherit me-1 material-icon-wrapper-small lh-1">${icon}</span>
                ` : ''}
                ${settings.message}
                ${!settings.disableCloseButton ? `
                    <button type="button" class="btn-close position-absolute right-0 top-0 p-1 my-0 me-4" data-bs-dismiss="alert" aria-label="Close"></button>
                ` : ''}
            </div>`;
        feedbackElement.append(alert);

        if (!settings.disableAutoClosing) {
            setTimeout(() => {
                alert.remove();
            }, settings.timeout);
        }
    }
}

module.exports = {
    showToastMessage: showToastMessage
};
